import styled, { css } from 'styled-components';
import { mapRoleToBorderColor } from '../theme';
import { DimensionStyle, InteractiveStyle, ShadowStyle } from '../layout';
import _ from 'lodash';
import { BackgroundStyle } from './styles';

const mapBorderRadius = {
  circle: '50%',
  small: '3px',
  medium: '5px',
  large: '8px',
  xLarge: '24px',
};

const mapBorderRadiusByType = (type) => mapBorderRadius[type] || '0px';

export const BorderStyle = css`
  border-radius: ${({ radius }: any) => mapBorderRadiusByType(radius)};
  border-width: ${({ borderSize }: any) =>
    _.flow((borderSize) =>
      _.map(borderSize, (value) => {
        return `${value}px`;
      }).join(' ')
    )(borderSize)};
  border-color: ${({ borderRole }: any) => mapRoleToBorderColor(borderRole)};
  border-style: solid;
  position: relative;
  overflow: ${({ overflow }: any) => overflow};
  ${DimensionStyle}
  ${BackgroundStyle}
`;

export const Border = styled.div<any>`
  ${BorderStyle}
`;

export const AnimatedBorder = styled.div<any>`
  transition: 1s all;
  ${BorderStyle}
`;

export const ShadowedBorder = styled.div<any>`
  ${ShadowStyle}
  ${BorderStyle}
`;

export const InteractiveBorder = styled.div<any>`
  ${InteractiveStyle}
  ${BorderStyle}
    :hover {
    transition: all 0.15s linear 0s;
    opacity: ${({ opacity }: any) => opacity};
  }
`;
